<template>
	<el-main>
		<Banner :dataimgs="dataimgs" />
		<IndustryIntro :data="intros" />
		<IndustryPainSpot :data="pains" />
		<Decoration />
		<IndustryArc :data="arcImg" />
	</el-main>
</template>

<script>
	import Banner from './Banner'
	import IndustryIntro from './IndustryIntro'
	import IndustryPainSpot from './IndustryPainSpot'
	import Decoration from './Decoration'
	import IndustryArc from './IndustryArc'
	export default {
		name: 'PortalIndustry',
		components: {
			Banner,
			IndustryIntro,
			IndustryPainSpot,
			Decoration,
			IndustryArc
		},
		data() {
			return {
				dataimgs: [{
					id: 0,
					url: 'https://sso.mopaas.com/login',
					title: '工业云平台',
					content: ['安全可靠的工业PaaS架构', '助理企业实现快速工业互联网转型和创新'],
					btn: '立即体验',
					src1: require('@/assets/images/industryBanner.jpg'),
					src2: require('@/assets/images/industryBanner-m.png'),
					platform:'感谢关注MoPaaS工业云平台，平台暂未开放公有云服务，如需试用，请联系客服。'
				}],
				intros: [{
						id: 0,
						title: '工业PaaS架构',
						content: '平台基于CloudFoundry、Docker和Kubernetes技术，迅速提升工业应用的开发、测试、部署效率。满足工业对于实时、可靠、安全的要求。',
						src: [require('@/assets/images/gongye1.png'), require('@/assets/images/gongye1_on.png')]
					}, {
						id: 1,
						title: '协议接入',
						content: '平台提供HTTP/HTTPS、TCP、MQTT等多种协议支持，实现数据的远程接入。通过工业网关提供OPC、Modbus、CAN、Profibus等各类工业通信协议的接入。',
						src: [require('@/assets/images/gongye2.png'), require('@/assets/images/gongye2_on.png')]
					},
					{
						id: 2,
						title: '工业微服务',
						content: '分布式注册中心、配置中心和消息总线等基础组件，并整合微服务架构治理体系，包括服务的调用频率、响应时间的监控、服务的限流、熔断等；',
						src: [require('@/assets/images/gongye3.png'), require('@/assets/images/gongye3_on.png')]
					},
					{
						id: 3,
						title: '大数据服务',
						content: '平台提供时序数据库、对象存储、关系型数据库、流数据引擎等数据库存储能力，以及大数据分析引擎、流数据处理引擎、实时处理算法、机器学习算法等大数据处理分析能力。',
						src: [require('@/assets/images/gongye4.png'), require('@/assets/images/gongye4_on.png')]
					}
				],
				pains: {
					title: 'MoPaaS工业云平台',
					content: '致力于解决以下行业痛点',
					items: [{
						id: 0,
						src: require('@/assets/images/gongye5.png'),
						content: '行业算法和模型库建立困难'
					}, {
						id: 1,
						src: require('@/assets/images/gongye6.png'),
						content: '开发工具服务零散异构'
					}, {
						id: 2,
						src: require('@/assets/images/gongye7.png'),
						content: '数据的实时性处理'
					}, {
						id: 3,
						src: require('@/assets/images/gongye8.png'),
						content: '网络与数据安全'
					}]
				},
				arcImg: require('@/assets/images/industry.png')
			}
		}
	}
</script>

<style>

</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalIndustry.vue